exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n@media only screen and (min-width: 992px){\n.el-col-md-6 {\n    width: 30%;\n}\n}\n\n", ""]);

// exports
